import { html } from 'lit-html';
import { ReviewAreaAction } from '../../../actions/review/review_area_action';
import { DeleteReviewModel } from '../../../models/review/review_js_env';
import { getAssetsUrlBase } from '../../../models/common/static_resource_util';

export const DeleteLink = (model: DeleteReviewModel) => {
  return model.deleteUrl
    ? html`
        <a
          href="javascript:;"
          @click=${() => ReviewAreaAction.openDeleteReviewConfirmModal(model)}
          class="a-textlink -iconfront"
        >
          <span class="a-icon -size20">
            <img class="a-icon_img" src="${getAssetsUrlBase()}images/icon_trash.svg" alt="" width="20" height="20" />
          </span>
          削除
        </a>
      `
    : html``;
};
